(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7693],{

/***/ 5577:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/website-unsubscribe",
      function () {
        return __webpack_require__(1199);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ website_unsubscribe; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(7066);
;// CONCATENATED MODULE: ./src/components/common/UnsubFormOnly.tsx





 // or you can use fetch
var UnsubFormOnly = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(""), email = ref[0], setEmail = ref[1]; // State for email
    // Set the default message when the `visitor` parameter is available
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var payload, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        payload = Object.fromEntries(new FormData(e.target));
                        payload.source = payload["form-name"] || "Website form";
                        delete payload["bot-field"];
                        _ctx.prev = 4;
                        _ctx.next = 7;
                        return axios/* default.post */.Z.post("/api/submit-form", payload);
                    case 7:
                        response = _ctx.sent;
                        if (response.status === 200) {
                            router.push("/thanks");
                        } else {
                            console.error("Failed to send message");
                        }
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](4);
                        console.error("Error sending message:", _ctx.t0);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    11
                ]
            ]);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        name: "Unsubscribe",
        method: "post",
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "hidden",
                name: "form-name",
                value: "Unsubscribe"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "d-none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        name: "bot-field"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row gx-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-6",
                        style: {
                            margin: "0 auto"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "form-floating mb-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    required: true,
                                    type: "email",
                                    name: "email",
                                    id: "form_email",
                                    className: "form-control",
                                    placeholder: "",
                                    value: email,
                                    onChange: function(e) {
                                        return setEmail(e.target.value);
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: "form_email",
                                    children: "Email *"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "valid-feedback",
                                    children: "Looks good! "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "invalid-feedback",
                                    children: "Please provide a valid email address. "
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "submit",
                            value: "Unsubscribe",
                            className: "btn btn-primary btn-send mb-3 d-inline-block",
                            style: {
                                width: 200
                            }
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var common_UnsubFormOnly = (UnsubFormOnly);

// EXTERNAL MODULE: ./src/components/common/SEO.tsx
var SEO = __webpack_require__(2034);
// EXTERNAL MODULE: ./src/data/keywords.ts
var keywords = __webpack_require__(4870);
// EXTERNAL MODULE: ./src/components/blocks/footer/index.ts + 21 modules
var footer = __webpack_require__(7702);
;// CONCATENATED MODULE: ./pages/website-unsubscribe/index.tsx






"use client";
var details = {
    pageName: "SEOptimist Agency London",
    categories: "seo, web design",
    description: "Transparent, affordable and effective technical SEO services in London for professionals, agencies and enterprise.",
    parentDirectories: ""
};
var WebsiteTester = function() {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "Unsubscribe",
                description: details.description,
                tag: details.categories,
                urlPT: "",
                urlENPT: "",
                url: "".concat(keywords.HomeList[0].title.toLowerCase().replace(/ /g, "-")),
                image: "img/".concat(keywords.HomeList[0].title.toLowerCase().replace(/ /g, "-"), ".jpg")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                className: "content-wrapper home",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "wrapper py-10",
                    style: {
                        backgroundColor: "#fff"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row gx-md-13 gy-5 align-items-start",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-12 relative order-1 order-lg-2 pb-15",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row",
                                    id: "contact",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-lg-10 col-xl-8 mx-auto pt-md-11 pt-lg-14",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "display-4 mb-3 text-center",
                                                children: "Unsubscribe"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "lead text-center mb-8 mx-auto",
                                                children: "Enter your email below and we will remove you from all further communication."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_UnsubFormOnly, {})
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* Footer1 */.gH, {
                address: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            keywords.SiteIdentity[0].address1,
                            ",",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " ",
                            keywords.SiteIdentity[0].address2,
                            ",",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " ",
                            keywords.SiteIdentity[0].address3
                        ]
                    })
                ],
                email: keywords.SiteIdentity[0].email,
                phone: keywords.SiteIdentity[0].phone
            })
        ]
    });
};
//@ts-expect-error - gen
WebsiteTester.bodyClass = "transparent";
/* harmony default export */ var website_unsubscribe = (WebsiteTester);


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(699)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2634,4870,4556,9774,2888,179], function() { return __webpack_exec__(5577); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);